<template>
  <div class="container-fluid py-5">
    <!-- Roles List -->
    <div class="d-flex justify-content-between">
      <h5>Roles</h5>
      <button
        @click="openAddRoleModal"
        class="bg-success btn text-white rounded py-0 m-0"
        :style="{ height: '35px' }"
      >
        Add New
      </button>
    </div>

    <div class="roles_">
      <div v-for="item in roles" class="_card" :key="item.id">
        <div class="header">
          <p class="" style="font-weight: 600">Total {{ item.user_count }} users</p>
        </div>
        <p>{{ item.role_name }}</p>
        <div class="d-flex gap-3">
          <template v-if="hasPermission('2023')">
            <button class="_button_branch" @click="openEditRoleModal(item)">Edit</button>
            <button class="_button_branch bg-danger text-white"  @click="statusRoleData(item.id,false)">Delete</button>
          </template>
        <!-- <button class="_button_branch bg-success text-white"  @click="statusRoleData(item.id,true)">Active</button> -->
        </div>
      </div>
    </div>

    <!-- Users Table -->
    <div class="row mt-5">
      <div class="col-12">
        <div class="card invoice p-0">
          <div class="d-lg-flex justify-content-between align-items-center mx-2 pb-0 card-header invoice">
            <h5>Users with Roles</h5>
          </div>
          <div class="px-0 pb-0 card-body">
            <div class="table-responsive" v-if="users.length > 0">
              <table class="table align-items-center mb-0">
                <thead>
                  <tr class="text-sm">
                    <th>Name</th>
                    <th>Email</th>
                    <th>Contact</th>
                    <th>Role</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(user, index) in users" :key="index">
                    <td>{{ user?.user?.username }}</td>
                    <td>{{ user?.user?.email }}</td>
                    <td>{{ user.number }}</td>
                    <td>{{ user.user_role }}</td>
                    <td>
                      <span :class="user.status ? 'active-status' : 'inactive-status'">
                        {{ user.status ? "Active" : "Inactive" }}
                      </span>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div v-else>
              <Skalaton />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Add/Edit Role Modal -->
    <div v-if="showModal" id="myModal" class="modal_class">
      <div class="modal-content dark-modeon">
        <span @click="toggleModal" class="close text-end">&times;</span>

        <div class="mb-4">
          <h5 class="mb-3">{{ isEditing ? "Edit Role" : "Add Role" }}</h5>
          
          <input
            type="text"
            v-model="roleForm.role_name"
            placeholder="Role Name"
            class="form-control invoice-card"
          />
          
        </div>

        <div class="permissions-container p-3" style="max-height: 500px; overflow-y: auto;">
          <div class="d-flex justify-content-end align-items-center mb-3">
            <input
            class="actions text-light"
              type="checkbox"
              id="selectAll"
              :checked="isAllChecked"
              @change="toggleAllPermissions"
            />
            <span for="selectAll" class="ms-2 text-xs">
              {{ isAllChecked ? "Uncheck All" : "Check All" }}
            </span>
          </div>
          <div
            class="permissions-row"
            v-for="(permission, index) in menus"
            :key="index"
          >
            <span class="text-sm">{{ permission.name }}</span>
            <div class="actions">
              <input
                type="checkbox"
                :checked="roleForm.permissions.includes(permission.id)"
                @change="togglePermission(permission.id)"
              />
            </div>
          </div>
        </div>

        <div class="flex text-center">
          <div class="grid grid-cols-2 gap-2">
            <button class="btn btn-secondary mx-3" @click="toggleModal">Cancel</button>
            <button class="btn btn-success" @click="submitRole">
              {{ isEditing ? "Update" : "Submit" }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted,computed } from "vue";
import { useUserApi } from "../services/user.service";
import showSwal from "@/mixins/showSwal.js";
import { hasPermission } from "@/utils/permissions.js";

const showModal = ref(false);
const isEditing = ref(false);
const roleForm = ref({ id: null, role_name: "", permissions: [] });
const users = ref([]);
const roles = ref([]);
const menus = ref([]);

const getUserData = async () => {
  try {
    const response = await useUserApi().getUserData();
    users.value = response;
  } catch (error) {
    console.error("Error fetching users:", error);
  }
};

const getRoleData = async () => {
  try {
    const response = await useUserApi().getRoleUserData();
    roles.value = response;
  } catch (error) {
    console.error("Error fetching roles:", error);
  }
};

const getMenuData = async () => {
  try {
    const response = await useUserApi().getMenuData();
    menus.value = response;
  } catch (error) {
    console.error("Error fetching menus:", error);
  }
};

onMounted(() => {
  getUserData();
  getRoleData();
  getMenuData();
});

// Computed property to check if all permissions are selected
const isAllChecked = computed(() => {
  return roleForm.value.permissions.length === menus.value.length;
});

const toggleAllPermissions = () => {
  if (isAllChecked.value) {
    roleForm.value.permissions = [];
  } else {
    roleForm.value.permissions = menus.value.map((menu) => menu.id);
  }
}

const toggleModal = () => {
  showModal.value = !showModal.value;
  if (!showModal.value) resetForm();
};

const openAddRoleModal = () => {
  isEditing.value = false;
  toggleModal();
};

const openEditRoleModal = async (role) => {

  if (!hasPermission('2024')) {
    showSwal.methods.showSwal({
      type: "error",
      message: "You don't have permission to edit roles.",
    });
    return;
  }

  isEditing.value = true;
  // alert(role.id)
  const single_role = await useUserApi().getSingleRoleData(role.id);
  roleForm.value = {
    id: single_role.id,
    role_name: single_role.name,
    role_code: single_role.code,
    active: single_role.active,
    permissions: single_role.menus.map(menu => menu.id) 
  };
  toggleModal();
};

const resetForm = () => {
  roleForm.value = { id: null, role_name: "", permissions: [] };
};

const togglePermission = (permission) => {
  const index = roleForm.value.permissions.indexOf(permission);
  if (index > -1) {
    roleForm.value.permissions.splice(index, 1);
  } else {
    roleForm.value.permissions.push(permission);
  }
};

const statusRoleData = async (id) => {
  if (!hasPermission('2024')) {
    showSwal.methods.showSwal({
      type: "error",
      message: "You don't have permission to delete roles.",
    });
    return;
  }
  await useUserApi().statusSingleRoleData(id);
  showSwal.methods.showSwal({
                type: "success",
                message: "Status Updated successfully!",
            });
  getRoleData();
};
const generateUniqueCode = () => {
  return `ROLE-${Date.now()}-${Math.floor(Math.random() * 1000)}`;
};

const submitRole = async () => {
  try {
    console.log(roleForm.value)
    const apiPayload = {
      name: roleForm.value.role_name,
      code: isEditing.value ? roleForm.value.role_code : generateUniqueCode(),
      active: true, 
      menu_ids: menus.value
        .filter((menu) => roleForm.value.permissions.includes(menu.id))
        .map((menu) => menu.id), 
    };

    if (isEditing.value) {
      // alert(roleForm.value.id)
      await useUserApi().updateRole(apiPayload, roleForm.value.id);
    } else {
      await useUserApi().createRole(apiPayload);
    }

    getRoleData();
    toggleModal();
  } catch (error) {
    console.error("Error submitting role:", error);
  }
};
</script>


<style scoped>
.roles_ {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
  margin-top: 30px;
}

._card {
  border-radius: 10px;
  padding: 20px;
  color: rgba(0, 0, 0, 0.589);
  display: flex;
  flex-direction: column;
  gap: 5px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
}
.dark-mode ._card {
  background-color: #061f3e;
}

.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.avatars {
  display: flex;
  align-items: center;
  gap: 5px;
}

.avatars span {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  background-color: rgb(0, 195, 255);
  transform: translateX(10px);
}

h3 {
  font-size: 16px;
  margin: 0;
}

._button {
  align-self: flex-start;
  color: #4e8aff;
  border: none;
  font-size: 14px;
  padding: 0px 8px;
  border-radius: 10px;
  font-weight: 500;
}

.dark-mode ._button {
  background-color: #4e89ff00;
}

._button:hover {
  background-color: #4e89ff1c;
}

/* ############ modal############### */
/* The Modal (background) */
.modal_class {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 1000000 !important;

  overflow: auto;
  background: #aaaaaa;
}

/* Modal Content/Box */
.modal-content {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 50%;
  max-width: 650px;
  padding: 20px;
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

/* Close Button */
.close {
  color: #aaaaaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
}

.close:hover,
.close:focus {
  color: #000;
  text-decoration: none;
  cursor: pointer;
}

._button_branch {
  align-self: flex-start;
  color: #4e8aff;
  border: none;
  font-size: 14px;
  padding: 0px 8px;
  border-radius: 10px;
  background-color: #4e89ff1a;
  font-weight: 500;
}

/* ########################## */
.permissions-wrapper {
  font-family: Arial, sans-serif;
  max-width: 800px;
  margin: 20px auto;
  padding: 20px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color: #f9f9f9;
}

.permissions-container {
  display: flex;
  flex-direction: column;
}

.permission-header {
  display: flex;
  justify-content: space-between;
  font-weight: bold;
  margin-bottom: 8px;
}

.permissions-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 0;
  border-top: 1px solid #e0e0e0;
}

.permissions-row:first-of-type {
  border-top: none;
}

.actions {
  display: flex;
  gap: 10px;
}

.checkbox {
  display: flex;
  align-items: center;
  gap: 5px;
  font-size: 14px !important;
}

input[type="checkbox"] {
  width: 14px;
  height: 17px;
  border-radius: 10px !important;
}

._check {
  cursor: pointer !important;
  font-weight: 500 !important;
}
</style>
